import { useState, useEffect } from 'react';
import translate from 'translate';
import Cookies from 'js-cookie';

translate.engine = "google";

const useTranslateAnalysis = (analysisResults) => {
  const [translatedResults, setTranslatedResults] = useState(analysisResults);
  const [isTranslating, setIsTranslating] = useState(false);
  const [lang, setLang] = useState(Cookies.get('isDutch') === 'true' ? 'nl' : 'en');

  useEffect(() => {
    const checkLanguage = () => {
      const cookieIsDutch = Cookies.get('isDutch') === 'true';
      const newLang = cookieIsDutch ? 'nl' : 'en';
      if (newLang !== lang) {
        setLang(newLang);
      }
    };
    checkLanguage();
    const interval = setInterval(checkLanguage, 1000);
    return () => clearInterval(interval);
  }, [lang]);

  useEffect(() => {
    const translateResults = async () => {
      if (!analysisResults) return;
      
      // if the language is English no need to translate
      if (lang === 'en') {
        setTranslatedResults(analysisResults);
        return;
      }
      
      setIsTranslating(true);
      try {
        const targetLang = 'nl'; // only need to translate to Dutch
        const sourceLang = 'en'; //

        const translated = JSON.parse(JSON.stringify(analysisResults));

        // Helper to update state with a deep copy to trigger React update
        const updateCallback = (updatedObj) => {
          setTranslatedResults(JSON.parse(JSON.stringify(updatedObj)));
        };

        const translateObject = async (obj, updateCallback) => {
          for (let key in obj) {
            if (typeof obj[key] === 'string') {
              try {
                obj[key] = await translate(obj[key], { to: targetLang, from: sourceLang });
                updateCallback(translated); // update after each string
              } catch (error) {
                console.error(`Translation error for key ${key}:`, error);
                obj[key] = obj[key];
              }
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
              await translateObject(obj[key], updateCallback);
            }
          }
        };

        await translateObject(translated, updateCallback);
        setTranslatedResults(translated);
      } catch (error) {
        console.error('Translation error:', error);
        setTranslatedResults(analysisResults);
      } finally {
        setIsTranslating(false);
      }
    };

    if (analysisResults && lang === 'nl') {
      translateResults();
    } else if (analysisResults) {
      setTranslatedResults(analysisResults);
    }
  }, [analysisResults, lang]);

  useEffect(() => {
    if (analysisResults) {
      setTranslatedResults(analysisResults);
    }
  }, [analysisResults]);

  return { translatedResults, isTranslating };
};

export default useTranslateAnalysis; 